import React from 'react';
import { currency } from 'src/utils/utils';
import styles from './SellDeductionReviewModal.module.scss';
import { specialStates } from '../../../../settings/settings';

// TODO-College distribute flow has been broken into its own component. Checks for isCollegeDistribute can be
// safely removed from this component.
const SellDeductionReviewModal = ({ selectedFunds }) => {
  const deductionRow = 'deduction-row';
  const deductionTitle = 'deduction-title';
  const deductionAmount = 'deduction-amount';
  return (
    <div>
      <div className={styles['review-title']}>Total Deductions Summary</div>
      {selectedFunds.map((fund, i) => {
        const isFederalState =
          fund.address?.state && specialStates.includes(fund.address?.state);

        return (
          <div key={i + 1} className={styles['fund-block']}>
            <div className={styles['fund-title']}>
              {fund.fundName}{' '}
              <span className={styles['ticker']}>{fund.ticker}</span>
            </div>
            <div className={styles[deductionRow]}>
              <div className={styles[deductionTitle]}>
                Redemption Amount in Dollars
              </div>
              <div className={styles['redemption-amount']}>
                {currency(fund.grossAmountDollars)}
              </div>
            </div>

            {fund.closeout && (
              <div className={styles[deductionRow]}>
                <div className={styles[deductionTitle]}>Administrative Fee</div>
                <div className={styles[deductionAmount]}>
                  -{currency(fund.closeoutFee)}
                </div>
              </div>
            )}
            {!fund.nonRetirementLike && (
              <>
                <div className={styles[deductionRow]}>
                  <div className={styles[deductionTitle]}>
                    Federal Income Tax Withholding{' '}
                    {fund.federalWithholdingPercent}%
                  </div>
                  <div className={styles[deductionAmount]}>
                    -{currency(fund.federalWithholdingDollars)}
                  </div>
                </div>
                {fund.stateWithholdingApplied ? (
                  <div className={styles[deductionRow]}>
                    <div className={styles[deductionTitle]}>
                      Mandatory {fund.address?.state}
                      <span>
                        {' '}
                        State Income Tax Withholding{' '}
                        {fund.stateWithholdingPercent}%{' '}
                        {isFederalState ? ' of Federal' : ''}
                      </span>
                    </div>
                    <div className={styles[deductionAmount]}>
                      -{currency(fund.stateWithholdingDollars)}
                    </div>
                  </div>
                ) : (
                  <div className={styles[deductionRow]}>
                    <div className={styles[deductionTitle]}>
                      State Income Tax Withholding
                    </div>
                    <div className={styles[deductionAmount]}>
                      Amount Not Available
                    </div>
                  </div>
                )}
              </>
            )}
            <div className={styles['take-home-row']}>
              <div className={styles['total-take-home-title']}>
                Estimated Take-Home Amount
              </div>
              <div className={styles['redemption-amount']}>
                {currency(fund.grossAmountDollars - fund.totalDeductions)}
              </div>
            </div>
            <div className={styles['estimated-amounts-note']}>
              Estimated amounts may differ due to market value at the time the
              trade is placed.
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SellDeductionReviewModal;
